/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-param-reassign */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, useReducer } from 'react'

import { connect, useDispatch,useSelector } from 'react-redux'
import PropTypes, { object } from 'prop-types';
import clsx from "clsx";
import TablePagination from "@mui/material/TablePagination";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import { Modal, Dialog, DialogTitle, DialogContent, DialogActions, Box, TextField, Grid, FormGroup, IconButton } from '@material-ui/core'; // Remove the unused imports for CHG0073013
import { MdReplay } from 'react-icons/md';
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Truckloading from "../CvLoader/Cvloader";
import ReportTable from '../ReportTableComponent/ReportTable';
import { usePopupManager } from "../../providers/PopupManager/PopupManager";

import { DATE_FORMAT, API_RESOURCE_URLS, DISPLAY_MESSAGES, MESSAGE_TYPE, RESOURCE_TYPE, USER_OPERATIONS, Regex } from '../../constants';

import Table from '../Table/Table';
import {
  CustomDatePicker,
  CustomFormGroup,
  CustomSelect,
  ValidatingTextField,
} from "../FormComponents";
import { Button } from "../../atomicComponents";
import styles from "./SupOpReport.module.css";
import { withAllowedOperationsProvider } from '../../hocs'
import { setLogin } from '../../redux/features/auth/actions';
import { sanitizeCoCodeNumeric } from '../../utils/utils';


const useStyles = makeStyles((theme) =>
  createStyles({
    smallRadioButton: {
      "& svg": {
        width: "0.7em",
        height: "0.7em",
      },
    },
  })
);

function UnallocatedOperatorReport() {
const auth = useSelector((state) => state.auth); // useSelector
const baseUrl = useSelector((state) => state.counter.baseUrl); // useSelector
const { showPopup } = usePopupManager();
const history = useHistory();
const [myState, setState] = React.useState({
  poNo: "",
  stmNo: "",
  pers_no: "",
  strworkarea: { label: "All", value: "" },
  BCName: "",
  bcno: { label: "All", value: "" },
  barrel: { label: "", value: "" },
  creation_date: "",
  insrtby: "",
  ProjectDescription: { label: "", value: "" },
  InsertEMP: "",
  action: "",
  chassisNo: null,
  toDate: null,
  fromDate: null,
  bodyBuilder: null,
  checkFlag: false,
});
  const classes = useStyles();
  let {
    userName,
    personNumber,
    companyCode,
    userRole,
    } = auth;

  const [resetAllVisitedFields, setResetAllVisitedFields] = useState(false);
  const [highlightMandatoryFields, setHighlightMandatoryFields] =
    useState(false);
  const handleOpen = () => setIsPopupOpen(true);
  const handleClose = () => setIsPopupOpen(false);
  const [tableArray, setTableArray] = useState([]);
  const [allTableData,setAllTableData]=useState([]);
  const [typeOfReport, setTypeOfReport] = useState("");
  const [tableData, setTableData] = useState([]);
  const [backgroundColors, setBackgroundColors] = useState({
    processInfoBg: true,
    supplierInfoBg: false,
    poInfoBg: false,
    projectsInfoBg: false,
  });
  const [reportTypeDropDown, setReportTypeDropDown] = useState([
    { value: "unallocated", label: "UNALLOCATED OPERATOR REPORT" },
    { value: "supervisor", label: "SUPERVISOR OPERATIVE REPORT" },
  ]);
  const [selectedReportType, setSelectedReportType] = useState("");
  const changeBackgroundColor = (field) =>
    setBackgroundColors((prev) => {
      const newBackgroundColors = {};
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(prev)) {
        if (key === field) newBackgroundColors[key] = true;
        else newBackgroundColors[key] = false;
      }
      return newBackgroundColors;
    });
  const ROW_HEIGHT = 38;
  const [loading, setLoading] = React.useState(false);
  const [viewDisplay, setViewDisplay] = useState(false);
  const [asnCount, setAsnCount] = useState(0);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const dispatchNew = useDispatch();

  const HEIGHT = '300px';
  const FILENAME = 'Supervisor_Operative_Report';

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    setViewDisplay(true);
    setRowsPerPage(10)
    setLoading(true);
    if (userRole.includes("SA")) {
      userRole = "SA";
    } 

    let apiFormatedData = {
      comp_code: sanitizeCoCodeNumeric(companyCode),
    };
    var apiFormatedDataJson = JSON.stringify(apiFormatedData);
    let headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    fetch(`${baseUrl}reports/SupOprReport`, {
      method: "POST",
      headers: headerss,
      credentials:'include',
      body: apiFormatedDataJson,
    })
      .then((response) => {
        
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
        let responsecode=response.status
        if(responsecode===403){
         setLoading(false);
        }
        return response.json();
        })
      .then((responseJson) => {
        if (responseJson.msg=="Success" && responseJson.data?.length != 0) {
          setLoading(false);
          setState((prevState) => ({ ...prevState, tableFlag: true }));
          const finalList = [];
          responseJson.data.map((row, index) => {
            finalList.push({
              id: index,
              ...row,
            });
          });
          setAllTableData(finalList)
         setTableArray(finalList)
        } 
        else if(responseJson.msg=="Success" && responseJson?.data?.length == 0) {
          setAllTableData([])
          setLoading(false);
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: "No Records Found",
        })
        }
        else if(responseJson && responseJson.msg=="Fail")  {
          setAllTableData([])
          setLoading(false);
          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: responseJson.data,
        })
        }
        setState((prevState) => ({ ...prevState, tableFlag: true }));
      })
      .catch((error) => {
        setLoading(false);
        setAllTableData([])
        if (error.response) {
          showPopup({
                  type: MESSAGE_TYPE.FAILURE,
                  contextText: MESSAGE_TYPE.FAILURE,
                  info: "Oops! Something went wrong. Please try again later. Please try again later",
              })
        }
        else {
          showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                info: "There might be Network issue, please try after some time",
            })
        }
      });

    
  }, []);

    const baseDefaultColumns = [
      {
        width: 100,
        title:'Supervisor BC Number',
        field: 'sup_bcno',
        enableSearch: true,
        enableFilter: true,
      },
      {
        width: 222,
        title: ' Supervisor BC Description',
        field: 'sup_bc_desc',
        enableSearch: true,
        enableFilter: true,
      },
      
      
      {
        width: 100,
        title: ' Supervisor ID',
        field: 'sup_tktno',
        enableSearch: true,
        enableFilter: true,
      },
      {
        width: 175,
        title: 'Supervisor Name',
        field: 'sup_name',
        enableSearch: true,
        enableFilter: true,
      },
      {
        width: 100,
        title: 'Supervisor Grade',
        field: 'sup_grade',
        enableSearch: true,
        enableFilter: true,
      },
     {
        width: 120,
        title: 'Employee BC Number',
        field: 'emp_bcno',
        enableSearch: true,
        enableFilter: true,
      },
     {
        width: 220,
        title: 'Employee BC Description',
        field: 'emp_bc_desc',
        enableSearch: true,
        enableFilter: true,
      },
      {
        width: 100,
        title: 'Employee ID',
        field: 'emp_tkt_no',
        enableSearch: true,
        enableFilter: true,
      },
      {
        width: 160,
        title: 'Employee Name',
        field: 'emp_name',
        enableSearch: true,
        enableFilter: true,
      },
      {
        width: 100,
        title: 'Employee Grade',
        field: 'emp_grade',
        enableSearch: true,
        enableFilter: true,
      },
      ];

      const resetFields = () => {
        
        setBcName(null);
        setBu(null);
        setBarrel(null);
        setProjDescp(null);
    
      }
  

  const setCount = (count) => {
    setAsnCount(count);
  };

  function downloadExcel(data) {
    const columnsKeys = {
    'Supervisor BC Number': 'sup_bcno',
        ' Supervisor BC Description': 'sup_bc_desc',
        ' Supervisor ID': 'sup_tktno',
        'Supervisor Name': 'sup_name',
        'Supervisor Grade': 'sup_grade',
        'Employee BC Number': 'emp_bcno',
        'Employee BC Description': 'emp_bc_desc',
        'Employee ID': 'emp_tkt_no',
        'Employee Name': 'emp_name',
        'Employee Grade': 'emp_grade',
    }
    data.forEach((item, index) => {item.id = index + 1;});
    const updateExportData = data.map(dict => Object.keys(dict).reduce((acc, key) => {
      acc[columnsKeys[key] || key] = dict[key];
      return acc;
    }, {}));
    const sheet = XLSX.utils.json_to_sheet(updateExportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, sheet, 'Sheet1');
    XLSX.writeFile(workbook, 'Linkagedetails.xlsx');
  }
  const renderTable = () => (
    <div
      className={styles.formGroup}
    >
      <div
        className={styles.col2} style={{
          width: "100%",
          height: "100%",
          marginTop: "10px"
        }}
      >
          <ReportTable columns={baseDefaultColumns} data={allTableData} height={HEIGHT} fileName={FILENAME}/>
        
       
      
      </div>
    </div>
  );


  return (
    <>
      <div
        className={clsx(
          styles.scrollContainer,
          styles.formContainer
        )}
      >        {
          tableData.length == 0 &&
        <CustomFormGroup header="Supervisor-Operative Report" body={renderTable()} />
        
        }
          {loading ? (
          <div style={{textAlign:"center",display:"flex",justifyContent:"center",marginTop:"40px"}}>
               <Truckloading />
            </div>
       
        ) : ""} 
      </div>
      <ResetModal
        isPopupOpen={isPopupOpen}
        handleClose={handleClose}
        resetFields={resetFields}
      />
    </>
  );
}
function ResetModal({ isPopupOpen, handleClose, resetFields }) {
  return (
    <Dialog
      open={isPopupOpen}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <MdReplay style={{ height: '18px', width: '18px' }} />
            <span className={styles.txt}>Reset</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>
            Are you sure you want to reset the filters?
          </span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(
              styles.actionButton,
              styles.transparentButton
            )}
            onClick={handleClose}
          >Cancel</Button>
          <Button
            className={clsx(
              styles.actionButton,
              styles.primaryActionButton,
            )}
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              handleClose()
              resetFields()
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  )
}
function ResetModal1({ a, handleCase, onDelete }) {
  return (
    <Dialog
      open={a}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup1"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <span className={styles.txt}>Are you sure ?</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>
            Do you want to delete ?
          </span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(
              styles.actionButton,
              styles.transparentButton
            )}
            onClick={handleCase}
          >Cancel</Button>
          <Button
            className={clsx(
              styles.actionButton,
              styles.primaryActionButton,
            )}
            variant="primary"
            onClick={onDelete}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  )
}
UnallocatedOperatorReport.propTypes = {
  redirectToProcessPage: PropTypes.func
}

ResetModal.propTypes = {
  isPopupOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  resetFields: PropTypes.func.isRequired
}
ResetModal1.propTypes = {
  a: PropTypes.bool.isRequired,
  handleCase: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
}


const mapStateToProps = state => ({
  product: state.product,
  counter: state.counter.value,
  baseUrl: state.counter.baseUrl,
  auth: state.auth
});
const mapDispatchToProps = (dispatch) => ({

  fetchChassis: (chassisParam) => dispatch(fetchChassis(chassisParam)),
  getInvoice: (chassisParam) => dispatch(getInvoice(chassisParam)),
});
UnallocatedOperatorReport.propTypes = {
  counter: PropTypes.number,
  baseUrl: PropTypes.string,
  product: PropTypes.object,
  auth: PropTypes.object,
};
const App = connect(mapStateToProps, mapDispatchToProps)(UnallocatedOperatorReport);


export default withAllowedOperationsProvider(
  App,
  RESOURCE_TYPE.PPAP
);